import { render, staticRenderFns } from "./OfficeHours.vue?vue&type=template&id=3d4626fe"
import script from "./OfficeHours.vue?vue&type=script&lang=js"
export * from "./OfficeHours.vue?vue&type=script&lang=js"
import style0 from "./OfficeHours.vue?vue&type=style&index=0&id=3d4626fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports